// removed by extract-text-webpack-plugin
module.exports = {"container":"kmb8m","scrolled":"_2VrXw","fixed":"_22Pl7","content":"_1B3uF","dateInputs":"_12N5Q","dateRow":"FSouO","separator":"_3-4zp","destinationInput":"_2l8G2","destinationList":"_3Jfkz","destinationItem":"_1r84U","description":"_1VXEE","searchButton":"_2oDWG","permanence":"_3cIxm","permanenceRow":"_17ZE1","permanenceLabel":"_3u-5X","input":"_10szH"};


//////////////////
// WEBPACK FOOTER
// ./src/views/v2/search/components/searchBarDesktop/styles.module.css
// module id = 211
// module chunks = 0